// Copyright (c) 2017 Deere & Company

import './claim-search-details.scss';
import React, {PropTypes} from 'react';
import {
    getCreditMemoDisplayText,
    getCreditMemoFormName,
    getCreditMemoObjectId
} from '../../../shared/services/credit-memo-services';
import ClaimActionPopover from '../../shared/components/claim-action-button/claim-action-popover';
import ClaimSearchResult from '@deere/cps-it.warranty-model-factory/lib/claim-search-result';
import LabeledLink from '../../../product/shared/components/labeled-link';
import LabeledNode from '../../../shared/components/labeled-node';
import LabeledSmartFormLink from '../../../shared/components/labeled-smart-form-link/labeled-smart-form-link';
import LabeledString from '../../../shared/components/labeled-string';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildDate} from '../../../shared/services/build-date';
import {buildDealer} from '../../../shared/services/build-dealer';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';
import {getAllowedActions} from '../../shared/services/claim-shared-helper';
import {hasAccess} from '../../../shared/services/security';
import {hasCreditMemoAction} from '../../../shared/services/allowed-actions-services';

function handleActionClick(action) {

    const actionMethod = action.id === 'CRT' ?
        this.actions.updateCreateClaimModalVisibility.bind(null, true, this.claim.pin) : this.actions.handleSearchAction;

    actionMethod(this.claim, action);

}

const ClaimSearchDetails = (props, context) => {

    const allowedActions = getAllowedActions(props.isEditable, props.claim.allowedActions);

    return (
        <section className='claim-search-details'>
            <div className='row'>
                <LabeledString
                    className='lost-two-column'
                    data={buildDealer(props.claim.responsibleAccount, context.user.settings.dealer.displayFormat.key)}
                    label='DEALER_LOCATION'
                />
                <LabeledString
                    data={props.claim.referenceInfo.referenceNumber1}
                    label='WORK_ORDER_ONE'
                />
            </div>
            <div className='row'>
                <LabeledLink
                    className='lost-two-column'
                    data={props.claim.pin}
                    href={`#/products/${props.claim.pin}`}
                    label='PIN'
                />
                <LabeledString
                    data={props.claim.referenceInfo.referenceNumber2}
                    label='WORK_ORDER_TWO'
                />
            </div>
            <div className='row'>
                <LabeledNode
                    className='customer-link-item lost-two-column'
                    data={props.claim.customerSummary.displayName}
                    label='CUSTOMER'
                />
                <LabeledString
                    data={props.claim.referenceInfo.repairNumber}
                    label='REPAIR_NUMBER'
                />
            </div>
            {props.claim.subClaimType.key === 'PMI' &&
                <div className='row'>
                    <LabeledNode
                        className='lost-two-column'
                        data={props.claim.programName ? `${props.claim.programName} - ${props.claim.programDescription}` : ''}
                        label='PROGRAM'
                    />
                </div>
            }
            <div className='row'>
                <LabeledString
                    data={props.claim.failureInfo.failurePartNumber}
                    label='FAILED_PART'
                />
                <LabeledString
                    data={buildDate(props.claim.recordInfo.createdDate)}
                    label='CREATED'
                />
                <LabeledString
                    data={props.claim.recordInfo.createdBy.buildUserName()}
                    label='CREATED_BY'
                />

            </div>
            <div className='row'>
                <LabeledString
                    data={buildDate(props.claim.failureInfo.failureDate)}
                    label='FAILED'
                />
                <LabeledString
                    data={buildDate(props.claim.originalSubmissionDate)}
                    label='SUBMITTED'
                />
                <LabeledString
                    data={buildDate(props.claim.approvalDate)}
                    label='APPROVED'
                />
            </div>
            <div className='row'>
                <LabeledString
                    data={buildDate(props.claim.failureInfo.repairDate)}
                    label='REPAIRED'
                />
                <LabeledString
                    data={buildDate(props.claim.recordInfo.updatedDate)}
                    label='CHANGED'
                />
                {hasAccess(context.security, 'CLAIM', 'CLM_CREDIT_MEMO') && hasCreditMemoAction(props.claim.allowedActions) &&
                <LabeledSmartFormLink
                    displayText={getCreditMemoDisplayText(props.claim.claimValueDetails.creditMemoNumber)}
                    formName={getCreditMemoFormName(props.claim.claimValueDetails.creditMemoNumber)}
                    label='CREDIT_MEMO'
                    objectId={getCreditMemoObjectId(props.claim.claimValueDetails.creditMemoNumber, props.claim.claimNumber)}
                />
                }
            </div>
            <footer>
                {props.claim.allowedActions.length &&
                    <ClaimActionPopover
                        actions={allowedActions}
                        claimNumber={formatClaimNumber(props.claim.claimNumber)}
                        claimStatus={props.claim.claimStatus.key}
                        creditMemoNumber={props.claim.claimValueDetails.creditMemoNumber}
                        onActionClick={props::handleActionClick}
                    />
                }
            </footer>
        </section>
    );

};

ClaimSearchDetails.displayName = 'ClaimSearchDetails';
ClaimSearchDetails.propTypes = {
    actions: PropTypes.object.isRequired,
    claim: PropTypes.instanceOf(ClaimSearchResult).isRequired,
    isEditable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func
};
ClaimSearchDetails.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default ClaimSearchDetails;



// WEBPACK FOOTER //
// ./src/claim/claim-search/components/claim-search-details.js